import { defineMessages } from 'react-intl';

const messages = defineMessages({
  highVolumeShipmentExternalCarrierPerLabelPriceFootnote: {
    description: 'footnote which explains that each external carrier shipment will cost some fee and ShipStation Carriers is free',
    defaultMessage:
      "*Shipments created using <kb>your personal carrier accounts</kb> are subject to a fee of {fee}¢. Shipments created using ShipStation's pre-negotiated discounted shipping rates are exempt from this fee.",
    id: 'Z6uucc',
  },
});

export default messages;
